import React from "react";
import { Select, Tag } from "antd";

export default function FormSelectMultipleBoolean({
	inputValue,
	inputOnChange,
	disabledInput,
}: {
	inputValue: boolean[];
	inputOnChange: (newValue: boolean[]) => void;
	disabledInput: boolean;
}) {
	const { Option } = Select;

	// ************************************************ */
	// FUNCTIONS ************************************** */

	const handleAdd = (value: boolean) => {
		const newArray = [...inputValue, value];
		inputOnChange(newArray);
	};

	const handleRemove = (index: number) => {
		const newArray = inputValue.filter((_, i) => i !== index);
		inputOnChange(newArray);
	};

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>Data</span>
				</div>

				<div className='generalStyles__width100'>
					<Select
						className='generalStyles__width100'
						size='small'
						placeholder='Add value'
						onChange={(value: boolean) => handleAdd(value)}
						disabled={disabledInput}
					>
						<Option value>true</Option>
						<Option value={false}>false</Option>
					</Select>

					{/* BOOLEAN ARRAY VISUALIZATION */}
					<div style={{ marginTop: 8 }}>
						{inputValue.map((val, index) => (
							<Tag
								key={index}
								color={val ? "green" : "red"}
								closable={!disabledInput}
								onClose={() => handleRemove(index)}
							>
								{val.toString()}
							</Tag>
						))}
					</div>
				</div>

				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}
